import MoveInformation from './MoveInformation';

export default MoveInformation;
